
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("46MuN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c6c10cedb8df6941$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $c6c10cedb8df6941$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': 'vzostupne',
    'fabric.editor.headingLink.copied': "Skop\xedrovan\xe9!",
    'fabric.editor.headingLink.copyAnchorLink': "Skop\xedrova\u0165 prepojenie do nadpisu",
    'fabric.editor.headingLink.copyAriaLabel': "Kop\xedrova\u0165",
    'fabric.editor.headingLink.descSortingLabel': 'zostupne',
    'fabric.editor.headingLink.failedToCopy': "Nepodarilo sa skop\xedrova\u0165",
    'fabric.editor.headingLink.noneSortingLabel': "\u017Eiadne",
    'fabric.editor.inlineComment.marker.end': "koniec vnoren\xe9ho koment\xe1ra",
    'fabric.editor.inlineComment.marker.start': "za\u010Diatok vnoren\xe9ho koment\xe1ra"
};

});


//# sourceMappingURL=sk.9fe29698.js.map
